const tabs = require('./tabs');
const fieldPassword = require('./forms/field-password');
const fieldTextarea = require('./forms/field-textarea');

module.exports = {
  init() {
    tabs.initAll();
    fieldPassword.initAll();
    fieldTextarea.initAll();
  },
};
